import React, { useEffect, useState } from 'react';
import { Box, Text, Flex } from 'rebass';
import Wrapper from './Wrapper';
import { get, patch, post } from 'utils/api';

const OptionRenderer = ({ hideSkip, onStepUp, onStepDown, surveyData, renderheader }) => {
    const [selectedValue, setSelectedValue] = useState(null);
    const [originalAnswer, setOrginialAnswer] = useState(null);

    async function getAnswer() {
        const { data } = await get(`/v3/surveys/${surveyData?.id}/questions/${surveyData?.attributes?.id}/answers`);

        const questionsResp = data?.initial?.data.find(({ relationships }) => relationships?.question?.data?.id === surveyData?.attributes?.id)

        setOrginialAnswer(questionsResp?.attributes)
        setSelectedValue(questionsResp?.attributes?.answer)
    }

    useEffect(() => {
        if (selectedValue && selectedValue !== originalAnswer?.answer) {
            onSubmit()
            return
        }
    }, [selectedValue, originalAnswer?.answer])

    useEffect(() => {
        if (surveyData?.id && surveyData?.attributes?.id)
            getAnswer()

        return () => {
            setSelectedValue(null)
            setOrginialAnswer(null)
        }
    }, [surveyData?.id, surveyData?.attributes?.id])

    async function onSubmit(e) {
        if (selectedValue !== originalAnswer?.answer) {
            if (originalAnswer?.answer) {
                await patch(`/v3/surveys/${surveyData?.id}/questions/${surveyData?.attributes?.id}/answers/${originalAnswer?.id}`,
                    { data: { attributes: { 'answer': selectedValue } } },
                )
            } else {
                await post(`/v3/surveys/${surveyData?.id}/questions/${surveyData?.attributes?.id}/answers`,
                    { data: { attributes: { 'answer': selectedValue } } },
                )
            }
        }

        onStepUp(e)
    }

    return (
        <Wrapper
            hideSkip={hideSkip}
            onSubmit={onSubmit}
            showFooter
            onBack={onStepDown}
            percentComplete={0}
            bg="aliceBlue"
            renderheader={renderheader}
        >
            <Box m="auto" my="6.7%" mt="2.35%" width={['92%', '92%', '33%']}>
                <Text mb="30px" color="codGrey"
                    fontFamily="Bitter"
                    fontSize={30}
                    lineHeight="120%"
                    letterSpacing="-0.18px"
                    textAlign="center">{surveyData?.attributes?.['question-text']}</Text>

                <Flex flexDirection="column" >
                    {surveyData?.attributes?.options?.options?.map(option => {
                        const isSelected = selectedValue === option

                        return <Flex
                            mb='2.2%'
                            flexDirection="column"
                            justifyContent="center" sx={{ border: `1.5px solid ${isSelected ? '#724086' : '#D1D1D1'}`, cursor: 'pointer', borderRadius: '23px' }}
                            alignItems="center"
                            bg={isSelected ? "#F5EEF8" : "white"}
                            px={["20px"]}
                            py={["10px"]}
                            height="max-content"
                            onClick={() => {
                                if (isSelected)
                                    setSelectedValue(null)
                                else
                                    setSelectedValue(option)
                            }}
                        >
                            <Text fontFamily="Poppins" color={isSelected ? "#724086" : "mineShaft"} maxWidth={320} textAlign="center" fontSize={18} lineHeight={"24px"} letterSpacing={"-0.6px"}>{option}</Text>
                        </Flex>
                    })}
                </Flex>

            </Box>
        </Wrapper>
    )
};

export default OptionRenderer;
